var map = {
	"./Abel Lu.jpg": 953,
	"./about-me-selfie.jpg": 711,
	"./burgercat.png": 533,
	"./discord-contact.png": 722,
	"./discord.png": 655,
	"./genshin.png": 601,
	"./github.png": 591,
	"./home-selfie.jpg": 795,
	"./home-selfie.png": 138,
	"./linkedin.png": 267,
	"./osu.png": 239,
	"./pokeball.png": 358,
	"./python.png": 210,
	"./r.png": 661,
	"./react.png": 47,
	"./spring.png": 110
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 303;